export default "__VITE_ASSET__C3oCpPlq__"